module.exports = __webpack_public_path__ + "static/media/fitness-person.94280f74.png";